import API_BASE from './config';

export function getRaceDrivers(raceId) {
    return fetch(`${API_BASE}/race-drivers?raceId=${encodeURIComponent(raceId)}`, {
        headers: { 'Accept': 'application/json' },
    })
        .then((res) => {
            if (!res.ok) throw new Error('Failed to fetch race drivers');
            return res.json();
        });
}

export function setRaceDrivers(raceId, driverIds) {
    return fetch(`${API_BASE}/race-drivers`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ raceId, driverIds }),
    })
        .then((res) => {
            if (!res.ok) throw new Error('Failed to set race drivers');
            return res.json();
        });
}

export function getTeamsWithExtraDrivers() {
    return fetch(`${API_BASE}/race-drivers/teams-with-extras`, {
        headers: { 'Accept': 'application/json' },
    })
        .then((res) => {
            if (!res.ok) throw new Error('Failed to fetch teams with extra drivers');
            return res.json();
        });
}
